import { render } from "./CarouselSteps.vue?vue&type=template&id=2f4ccda8&scoped=true"
import script from "./CarouselSteps.vue?vue&type=script&lang=js"
export * from "./CarouselSteps.vue?vue&type=script&lang=js"

import "./CarouselSteps.vue?vue&type=style&index=0&id=2f4ccda8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4ccda8"]])

export default __exports__